<template>
   <div class="select-wrapper" :class="{'layer-view': titleEnglish==='Layer View'}">
      <span class="select-title">{{ languageIsEnglish ? titleEnglish: titleNepali }}</span><br>
      <select v-model="computedValue" :name="titleEnglish">
         <option
            v-for="region in regions"
            :key="region.code"
            :value="region.code"
            >
            {{ languageIsEnglish ? region.titleEnglish : region.titleNepali }}
         </option>
      </select>
   </div>
</template>

<script>
export default {
   props: {
      value: {required: true},
      languageIsEnglish: { type: Boolean, required: true},
      titleNepali: { type: String, required: true},
      titleEnglish: { type: String, required: true},
      regions: { type: Array, required: true},
   },
   computed: {
      computedValue: {
         get()
         {
            return this.value;
         },
         set(value)
         {
            const parsedValue = ['00', '000', '0000'].includes(value) ? value : parseInt(value);
            this.$emit('input', parsedValue);
         }
      }
   },
}
</script>

<style lang="scss" scoped>
.select-wrapper {
   align-items: center;
   text-align: center;
   width: 150px;
}

.layer-view {
   position: absolute;
   left: 0em;
   top: 0em;
}

.select-title {
   font-size: 12px;
   font-weight: bold;
}

select {
   margin: 2px 4px;
   width: 145px;
   background: whitesmoke;
   border: solid 1px lightgrey;
   padding: 3px 12px;
   border-radius: 3px;
   box-shadow: inset 0 0 1px rgb(136, 136, 136);
   text-decoration: none;
   font-size: 14px;
   font-weight: 400;
   appearance: none;
   // text-align: center;
   // text-align-last: center;
   // -moz-text-align-last: center;
   cursor: pointer;

   &:focus {
      border: solid 1px #2362624f;
      box-shadow: 0 0 6px #d8ffff;
      outline: none;
      color: black;
   }
   
   option {
      background: #236262 !important;
      color: white !important;
   }
}
</style>